// 2023-24 imports
import SAP2324 from "../../pdfs/innovative_teaching_learning/23-24/SAPInnovativeTeachingLearningActivityReport.pdf";
import DSM2324 from "../../pdfs/innovative_teaching_learning/23-24/Innovative Teaching Learning on DSM 2024.pdf";
import RTES2324 from "../../pdfs/innovative_teaching_learning/23-24/Innovating Teaching Learning on RTES 2024.pdf";
import IOT2324 from "../../pdfs/innovative_teaching_learning/23-24/Innovating Teaching Learning on IoT 2024.pdf";
import OFC2324 from "../../pdfs/innovative_teaching_learning/23-24/innovative_teaching_learning_OFC_CASESTUDY.pdf";
// 2022-23 imports
import ED2223 from "../../pdfs/innovative_teaching_learning/22-23/ED_2022-23_Report_Case_Study_Report.pdf";
import OFC2223 from "../../pdfs/innovative_teaching_learning/22-23/Innovative Teaching Learning Pallavi Nair.pdf";
import MC2223 from "../../pdfs/innovative_teaching_learning/22-23/13 Innovative Teaching learning Microcontroller 2022-23.pdf";
// 2021-22 imports
import MC2122 from "../../pdfs/innovative_teaching_learning/21-22/Innovative Teaching learning Microcontroller 2021-22.pdf";
import VLAB2122 from "../../pdfs/innovative_teaching_learning/21-22/2_Report on Vlab ICMT.pdf";

const yearWisePractices = [
  {
    year: "2023-24",
    practices: [
      {
        index: 1,
        name: "Prof. Priya Deshpande",
        methods: "SEM V, IoT Lab: Introduction of real life experiment in IoT Lab; Kahoot Quiz for every lab experiment",
        hyperlink: IOT2324,
        outcomes: "Engagement, Application of Theory and Critical Thinking; Interative Learning, Competition & Collaboration",
        measures: "LAB ISE: Rubrics & Kahoot Quiz; Kahoot marks"
      },
      {
        index: null,
        name: "",
        methods: "SEM VI, RTES LAB: Open Book Assignment on design modelling of problem statement; MiniProject on RTOS problem statement",
        hyperlink: RTES2324,
        outcomes: "Enhance students' application of theory, critical thinking; Demonstrating practical skills in task management and real-time system design",
        measures: "ISE Marks"
      },
      {
        index: 2,
        name: "Dr Y S Rao",
        methods: "New Hardware related practicals are designed for COA Lab",
        outcomes: "More clarity about the organization",
        measures: "ESE"
      },
      {
        index: 3,
        name: "Dr. Reena Sonkusare",
        methods: "Sem V, DSP Applications ",
        outcomes: "Demonstrating Real time DSP Applications",
        measures: "LAB ISE Rubrics and Quiz"
      },
      {
        index: null,
        name: "",
        methods: "Sem VI, FOA Lab: Introduce HFSS industry software for Antenna Designing, Poster Presentation",
        outcomes: "Demonstrating applications of antenna in various domains",
        measures: "LAB ISE Rubrics and Quiz"
      },
      {
        index: 4,
        name: "Prof. Priya Deshpande, Dr. Amol Deshpande, Dr. Narendra Bhagat, Dr. Anand Mane, Dr. Santoshkumar Sabat",
        methods: "SEM II DSM LAB: Extra Experiment for Fast Learners",
        hyperlink: DSM2324,
        outcomes: "Enhanced Understanding of Advanced Concepts, Improved Problem-Solving Skills, Promotion of Independent Learning, Recognition and Reward",
        measures: "LAB ISE and student Feedback"
      },
      {
        index: 5,
        name: "Dr. Kiran Talele, Prof. Amol Deshpande, Prof. Milind Paraye",
        methods: "Sem-IV, Signals and Systems",
        outcomes: "Hardware realization of Analog Filters and included as one of the experiment in Lab",
        measures: "Lab ISE"
      },
      {
        index: 6,
        name: "Pallavi Nair",
        methods: "OFC CASE STUDY, 45 minutes presentation challenge (team activity), activity for fast learner: Task given during IITB co-teaching",
        hyperlink: OFC2324,
        outcomes: "Understanding real life scenario of OFC application and its implementation, analyzing the losses, creating report and presentation, Modal analysis of the optical fiber using MATLAB program",
        measures: "ISE Marks"
      },
      {
        index: 7,
        name: "Manisha Bansode",
        methods: "Apply Flipclassroom technique (Think Pair Share activity) in a SAP Class.",
        hyperlink: SAP2324,
        outcomes: "Activity significantly enhanced students' understanding of the ear's acoustical properties, neural spiking mechanisms, and dynamic range management. This interactive approach improved their critical thinking, problem-solving, communication, and collaboration skills, resulting in increased engagement and positive feedback.",
        measures: "Indirectly with ESE marks"
      }
    ]
  },
  {
    year: "2022-23",
    practices: [
      {
        index: 1,
        name: "Dr. Reena Sonkusare",
        methods: "Reveiw of Paper; Mini Project; Moodle based evaluation; Unique experiment data set",
        outcomes: "Promote lifelong learning, technical writing, and presentation skills; actively engage in team-based learning and promote self-learning.",
        measures: "Rubrics, implementation & demonstration of project, IEEE Paper & Patent; Class Assignment, Quiz; Viva, Authentic experimentation and Evaluation",
      },
      {
        index: 2,
        name: "Prof. Manish M Parmar",
        methods: "Evaluation tool as Moodle",
        outcomes: "",
        measures: "Rubrics based exam",
      },
      {
        index: 3,
        name: "Dr. Sukanya Kulkarni",
        methods: "Technical paper review activity in ITC and ADC course. Create your own Wiki assignment on applications of Error correction codes in ITC course",
        outcomes: "",
        measures: "Assessment using rubric and oral evaluation",
      },
      {
        index: 4,
        name: "Prof. Milind Paraye",
        methods: "Unique Aim for each student in lab",
        outcomes: "Promote self-learning",
        measures: "Viva, experimentation",
      },
      {
        index: 5,
        name: "Dr. Prashant Kasambe",
        methods: "Sem III Subject: Electronic Devices EC202",
        hyperlink: ED2223,
        outcomes: "Analysis of electronic circuits with moderate level of complexity than a usual circuit in study",
        measures: "Case Study",
      },
      {
        index: 6,
        name: "Dr. Prashant Kasambe/Dr. R. G. Sutar",
        methods: "Sem IV Subject: Analog Circuits EC502",
        outcomes: "Development of Block Diagram and Analysis of circuits based on Integrated Circuits",
        measures: "Case Study",
      },
      {
        index: 7,
        name: "Prof. Priya Deshpande",
        methods: "Sem IV Subject: Microcontroller",
        outcomes: "Demonstration on any given new Microcontroller development board with peer learning",
        hyperlink: MC2223,
        measures: "Assessment using rubric and oral evaluation",
      },
      {
        index: 8,
        name: "Pallavi Nair",
        methods: "Optical Fibre Communication : Case Study , Microwave Communication : Mini Project",
        hyperlink: OFC2223,
        outcomes: "Skill enhancement, real world problem solving, collaboration and team work",
        measures: "ISE Marks"
      }
    ],
  },
  {
    year: "2021-22",
    practices: [
      {
        index: 1,
        name: "Dr. Y.S. Rao",
        methods:
          "Mobile lab concept, Activity based learning, Solving real-life problems",
        outcomes:
          "Able to design, compare and analyze, understand real systems",
        measures: "Demonstration, participation in competitions",
      },
      {
        index: 2,
        name: "Dr. Reena Sonkusare",
        methods:
          "Reveiw of Paper, Mini Project, Moodle based evaluation, Unique experiment data set",
        outcomes:
          "Lifelong learning, technical writing and presentation skills, Engaged in Team effort, promote self-learning",
        measures:
          "Rubrics, implementation & demonstration of project, IEEE Paper & Patent; Class Assignment, Quiz; Viva, Authentic experimentation and Evaluation",
      },
      {
        index: 3,
        name: "Manish M Parmar",
        methods: "Different data sets for the same problem statement",
        outcomes: "Inducts and triggers individual thought process",
        measures: "Viva examination",
      },
      {
        index: 4,
        name: "Dr. Sujata Kulkarni",
        methods: "Google classroom",
        outcomes: "Engaged in learning and Team effort",
        measures: "Rubrics, Class Assignment, Quiz",
      },
      {
        index: 5,
        name: "Milind Paraye",
        methods: "Unique Aim for each student in lab, Mini project (Groupwise)",
        outcomes: "Promote self-learning, Engaged in learning and Team effort",
        measures: "Viva, experimentation",
      },
      {
        index: 6,
        name: "Pallavi Malame",
        methods:
          "Mini Project : Microwave Communication, Optical Communication: Case Study",
        outcomes:
          "Students made microwave passive devices to understand simulation and fabrication, implementing concepts in Matlab/Python for better visualization, such as losses in fiber and networks.",
        measures: "Report/Viva",
      },
      {
        index: 7,
        name: "Prof. P. V. Kasambe",
        methods:
          "Case Study Presentation cum Implementation, Virtual Lab developed by Amrita Vishwa Vidyalya (Vlab) for conducting labs on Semiconductor material characterization techniques.",
        hyperlink: VLAB2122,
        outcomes:
          "Engaged in learning and Team effort",
        measures: "Online",
      },
      {
        index: 8,
        name: "Prof. Priya Deshpande",
        methods: "Mini Project on given development board available in lab and not in syllabus",
        hyperlink: MC2122,
        outcomes: "Engaged in learning and Team effort",
        measures: "Rubrics, Class Assignment, Quiz",
      },
    ],
  },
  {
    year: "2020-21",
    practices: [
      {
        index: 1,
        name: "Dr. Y.S. Rao",
        methods: "Mobile Lab, Virtual Lab, Hardware simulation Lab techniques",
        outcomes:
          "Every student is able to implement hardware specific programs and applications",
        measures: "Demonstrations and participations in the events",
      },
      {
        index: 2,
        name: "Dr. R.R. Sawant",
        methods:
          "FE BET: (a) Redrafting of BEE Syllabus (b) Setting up an Online LAB Course for BEE (c) Recorded Video Lab Tutorials and Video lectures based on SEQUEL/SequelApp simulation (available at IIT Bombay Website) (d) Tried to innovate on setting ESE Papers, assignments and Quizzes",
        outcomes:
          "Increased interest in the subject, Improved understanding of topics",
        measures: "Improved Results",
      },
      {
        index: 3,
        name: "Dr. Reena Sonkusare",
        methods:
          "Batchwise Class Assignment, Mini Project, Unique experiment dataset",
        outcomes:
          "Engaged in learning and Team effort, Engaged in knowing the recent developments and research aspects, No copying",
        measures:
          "Assignment Evaluation, Flipped Classroom, Viva, Authentic experimentation",
      },
      {
        index: 4,
        name: "Manish M Parmar",
        methods: "Role Play during the class",
        outcomes: "Increased participation with peer interaction",
        measures: "Participation in the events",
      },
      {
        index: 5,
        name: "Dr Sukanya Kulkarni",
        methods:
          "Moodle based assessment & testmoz and programming based test for experiments, Miniproject, Research paper reading activity",
        outcomes:
          "Conceptual knowledge and understanding, Lifelong learning, technical writing and presentation skills, promote self-learning",
        measures:
          "MCQ Quizzes and programming, paper writing in IEEE format and demonstration of project, Viva, Submit answers to a given questionnaire",
      },
      {
        index: 6,
        name: "Dr. Sujata Kulkarni",
        methods:
          "Batchwise quizzes on flexiquiz platform, Technical Paper presentation",
        outcomes:
          "Self-confidence and time management using different digital platform, Enhance reading and analysing skills, Team work and aware the applications based on recent trends in network domain",
        measures:
          "Quiz evaluation, Flipped classroom, Evaluation through presentation with reference paper",
      },
      {
        index: 7,
        name: "Anand Mane",
        methods: "Hardware mini projects and presentation.",
        outcomes: "Enhance designing skills and presentation skills",
        measures: "Viva and demonstration of projects",
      },
      {
        index: 8,
        name: "Vijaya Kamble",
        methods:
          "Batchwise different problems, Individual lab Submissions, Industry Person Guest Lecture Lab Based Courses, Individual Miniproject for M.Tech, For B.Tech group of 3 students in project",
        outcomes:
          "Understanding of basics & practical demonstration, Representation skills, Industrial Technical skills improvements, Technical problem-solving, programming, writing, and presentation skills",
        measures:
          "Viva, Individual lab evaluation, Feedback, IEEE paper preparation, demonstration of project through oral presentation",
      },
      {
        index: 9,
        name: "Milind Paraye",
        methods:
          "Case study, Different values of parameters in problem statement for individual",
        outcomes: null,
        measures: "Viva and evaluation",
      },
      {
        index: 10,
        name: "Dr. Amol Deshpande",
        methods: "Collaboration of two courses",
        outcomes:
          "Students learned the skill of Paper writing and there are 3 Paper published",
        measures: "3 Paper acceptance in IEEE conference out of 18 papers",
      },
      {
        index: 11,
        name: "Pallavi Malame",
        methods:
          "Crosswords, Unscramble words, Microwave Snakes and Ladder, Mind/Memory/Concept Map Making, Weekly feedback System, Unique data set to all student, DRDO Guest Lecture, Discussion Forum/Online, IITK Virtual Lab, Amrita Edu Virtual Lab, Phet Colorado Lab Simulation, Unwinding Session",
        outcomes:
          "Engaged Learning, Simplification of concepts, Engagement and happiness of students, Exposure to industrial application, Intellectual debate and discussion, Easy Experimentation on an online platform, Stress Buster",
        measures:
          "Weekly Feedback, Rubric Evaluation, Quiz, Online",
      },
      {
        index: 12,
        name: "Sneha Weakey",
        methods:
          "Group Discussion, Find the word, Unique data set to all student, IIT Bombay Virtual Lab Visit, IITK Virtual Lab, Amrita Edu Virtual Lab, Batchwise Class Assignment, Mini Project",
        outcomes:
          "Engaged Learning, Simplification of concepts, Engagement of students, Awareness of Lab Processes",
        measures:
          "Weekly Feedback, Authentic Experimentation, and evaluation, Viva, and demonstration of projects, Flipped Classroom",
      },
      {
        index: 13,
        name: "Dr.D.C.Karia",
        methods:
          "Use of pen tab for teaching with resource sharing via Google Classrooms, Moodle",
        outcomes: "Effecting teaching",
        measures: "Online",
      },
      {
        index: 14,
        name: "Prof. G. T. Haldankar",
        methods: "Discussion forum created on MOODLE for two experiments.",
        outcomes: "Engaged in learning and Team effort",
        measures: "Online",
      },
      {
        index: 15,
        name: "Prof. P. V. Kasambe",
        methods:
          "Case Study Presentation cum Implementation, Virtual Laboratory to perform experiments on Electronics Circuits and Systems",
        outcomes:
          "Engaged in learning and Team effort, Awareness of Lab Processes",
        measures: "Online",
      },
      {
        index: 16,
        name: "Prof. Priya Deshpande",
        methods:
          "Hardware demos for Microcontroller Laboratory, Report on Debate/ Group Discussion for ISE Evaluation",
        outcomes: "Learn by doing, Intellectual debate and discussion",
        measures: "Online",
      },
      {
        index: 17,
        name: "Prof. N. A. Bhagat",
        methods:
          "Use of pen tab for teaching, Network Theory/Digital Circuits/VLSI LECTURES with table TOP Mobile capturing the A4 page video online.",
        outcomes: "Effecting teaching",
        measures: "Online",
      },
      {
        index: 18,
        name: "Prof. Najib Ghatte",
        methods:
          "Signal System lecture on Pentab and Demonstration session on Smart TV, Upload of lectures on YouTube for future perusal",
        outcomes: "Effecting teaching",
        measures: "Online",
      },
      {
        index: 19,
        name: "Dr. S.S. Rathod",
        methods: "Virtual lab visit and live demo for Electronic Device course",
        outcomes: "Easy Experimentation on online platform",
        measures: "Online",
      },
      {
        index: 20,
        name: "Prof. Manisha Bansode",
        methods: "IEEE paper implementation as Mini-Project IPA Lab",
        outcomes:
          "Engaged in knowing the recent developments and research aspects",
        measures: "Online",
      },
    ],
  },
  {
    year: "2019-20",
    practices: [
      {
        index: 1,
        name: "Dr. Y.S. Rao",
        methods: "Mobile Lab, Virtual Lab, Hardware simulation Lab techniques",
        outcomes:
          "Every student is able to implement hardware specific programs and applications",
        measures: "Demonstrations and participations in the events",
        class: "SE, TE, BE",
        sem: "All sems",
      },
      {
        index: 2,
        name: "Dr. R.R. Sawant",
        methods:
          "FE BET: (a) Redrafting of BEE Syllabus (b) Setting up an Online LAB Course for BEE (c) Recorded Video Lab Tutorials and Video lectures based on SEQUEL/SequelApp simulation (available at IIT Bombay Website) (d) Tried to innovate on setting ESE Papers, assignments and Quizes",
        outcomes:
          "Increased interest in the subject, Improved understanding of topics",
        measures: "Improved Results",
        class: "FE",
        sem: "I, II",
      },
      {
        index: 3,
        name: "Dr. Reena Sonkusare",
        methods:
          "Batchwise Class Assignment, Mini Project, Unique experiment dataset",
        outcomes:
          "Engaged in learning and Team effort, Engaged in knowing the recent developments and research aspects, No copying",
        measures:
          "Assignment Evaluation, Flipped Classroom, Viva, Authentic experimentation",
        class: "TE",
        sem: "Sem V, VI",
      },
      {
        index: 4,
        name: "Manish M Parmar",
        methods: "Role Play during the class",
        outcomes: "Increased participation with peer interaction",
        measures: "Participation in the events",
        class: "TE",
        sem: "Sem V, VI",
      },
      {
        index: 5,
        name: "Dr Sukanya Kulkarni",
        methods:
          "Moodle based assessment & testmoz and programming based test for experiments, Miniproject, Research paper reading activity",
        outcomes:
          "Conceptual knowledge and understanding, Lifelong learning and technical writing and presentation skills, promote self learning",
        measures:
          "MCQ Quizzes and programming, paper writing in IEEE format and demonstration of project, Viva, and demonstration of experiments, Submit answers to a given questionnaire",
        class: "TE, SE",
        sem: "III, IV, V, VI",
      },
      {
        index: 6,
        name: "Dr. Sujata Kulkarni",
        methods:
          "Batchwise quizzes on flexiquiz platform, Technical Paper presentation",
        outcomes:
          "Self confidence and time management using different digital platform, Enhance reading and analysing skills, Team work and aware the applications based on recent trends in network domain",
        measures:
          "Quiz evaluation, Flipped classroom, Evaluation through presentation with refernce paper",
        class: "TE",
        sem: "V, VI",
      },
      {
        index: 7,
        name: "Anand Mane",
        methods: "Hardware mini projects and presentation.",
        outcomes: "Enhance designing skills and presentation skills",
        measures: "Viva and demonstration of projects",
        class: "TE, BE",
        sem: "V, VI, VIII",
      },
      {
        index: 8,
        name: "Vijaya Kamble",
        methods:
          "Batchwise different problems,Individual lab Submissions, Industry Person Guest Lecture Lab Based Courses, Individual Miniproject for M.Tech,For B.Tech group of 3 students in project",
        outcomes:
          "Understanding of basics & practical demonstration, Representation skills, Industrial Technical skills improvements, Technical problem-solving, programming, writing skills",
        measures:
          "Viva, Individual lab evaluation, Feedback, IEEE paper preparation, demonstration of project through oral presentation",
        class: "TE, BE",
        sem: "VI, VII, VIII",
      },
      {
        index: 9,
        name: "Milind Paraye",
        methods:
          "Case study, Different values of parameters in problem statement for individual",
        outcomes: null,
        measures: "Viva and evaluation",
        class: "SE, TE",
        sem: "III, IV, V, VI",
      },
      {
        index: 10,
        name: "Dr. Amol Deshpande",
        methods: "Collaboration of two courses",
        outcomes:
          "Students learned the skill of Paper writing and there are 3 Paper published",
        measures: "3 Paper acceptance in IEEE conference out of 18 papers",
        class: "SE, FE",
        sem: "I, II, III VI",
      },
      {
        index: 11,
        name: "Pallavi Malame",
        methods:
          "Crosswords, Unscramble words, Microwave Snakes and Ladder, Mind/Memory/Concept Map Making, Weekly feedback System, Unique data set to all student, DRDO Guest Lecture, Discussion Forum/Online, IITK Virtual Lab, Amrita Edu Virtual Lab, Phet Colorado Lab Simulation, Unwinding Session",
        outcomes:
          "Engaged Learning, Simplification of concepts, Engagement and happiness of students, Exposure to industrial application, Intellectual debate and discussion, Easy Experimentation on an online platform, Stress Buster",
        measures:
          "Weekly Feedback, Rubric Evaluation, Quiz, Online",
        class: "TE, BE",
        sem: "VI, VII",
      },
      {
        index: 12,
        name: "Sneha Weakey",
        methods:
          "Group Discussion, Find the word, Unique data set to all student, IIT Bombay Virtual Lab Visit, IITK Virtual Lab, Amrita Edu Virtual Lab, Batchwise Class Assignment, Mini Project",
        outcomes:
          "Engaged Learning, Simplification of concepts, Engagement of students, Awareness of Lab Processes",
        measures:
          "Weekly Feedback, Authentic Experimentation, and evaluation, Viva, and demonstration of projects, Flipped Classroom",
        class: "SE, FE",
        sem: "I, II, III VI",
      },
    ],
  },

  {
    year: "2018-19",
    practices: [
      {
        index: 1,
        name: "Dr. Y.S. Rao",
        methods:
          "Mobile lab concept, Activity based learning, Solving real-life problems",
        outcomes:
          "Able to design, compare and analyze, understand real systems",
        measures: "Demonstration, participation in competitions",
        class: "SE",
        sem: "III, IV",
      },
      {
        index: 2,
        name: "Dr. Reena Sonkusare",
        methods:
          "Review of Paper, Mini Project, Moodle based evaluation, Unique experiment data set",
        outcomes:
          "Lifelong learning, technical writing and presentation skills, Engaged in learning and Team effort, promote self-learning",
        measures:
          "Submit answers to given Questionnaire, Rubrics, implementation & demonstration of project, IEEE Paper & Patent, Class Assignment, Quiz, Viva, Authentic experimentation and Evaluation",
        class: "TE",
        sem: "V, VI",
      },
      {
        index: 3,
        name: "Dr. Sujata Kulkarni",
        methods: "Google classroom",
        outcomes: "Engaged in learning and Team effort",
        measures: "Rubrics, Class Assignment, Quiz",
        class: "TE",
        sem: "V, VI",
      },
      {
        index: 4,
        name: "Milind Paraye",
        methods: "unique Aim for each student in lab, Mini project (Groupwise)",
        outcomes: "Promote self-learning, Engaged in learning and Team effort",
        measures: "Viva, experimentation",
        class: "SE",
        sem: "III, IV",
      },
      {
        index: 5,
        name: "Pallavi Malame",
        methods:
          "Mini Project : Microwave Communication, Optical Communication: Case Study",
        outcomes:
          "Microwave passive devices were made by the students this helped them understand simulation and fabrication process, Implementation of concepts in Matlab/Python for better visualization of difficult concepts like losses in fiber and networks",
        measures: "Report/Viva",
        class: "TE, BE",
        sem: "VI, IV",
      },
    ],
  },
];

export default yearWisePractices;
